import { flux } from './cash/flux'
import { referentiel } from './cash/referentiel'
import { settings } from './cash/settings'
import { statement } from './cash/statement'
import { treatment } from './cash/treatment'
import { accounting } from './cash/accounting'
import { accounting_export } from './cash/accounting-export'
import { communication } from './administration/communication'
import { interfaces } from './administration/interfaces'
import { parametrage } from './administration/parametrage'
import { customisation } from './administration/customisation'
import { audit } from './administration/audit'
import { ratecurrency } from './cash/rate-currency'
import { remuneration } from './treasury/remuneration'
import { generale } from './generale/index'
import { quotidienne } from './treasury/quotidienne'
import { reporting } from './treasury/reporting'
import { Settings } from './treasury/settings'
import { currentAccount } from './treasury/currentAccount'
import { evenement } from './treasury/evenement'
import { debt } from './treasury/debt'
import { widget } from './dashboard/widget'
import { composant } from './composant/composant'
import { document } from './document/document-signataire'
import { BoLangues } from './bo/bo-langues'
import { operationChange } from './risk/change-operation'
import { cotationChange } from './risk/change-cotation'
import { Budgets } from './treasury/budget'

export const languageResourceFr = {
  translation: {
    ...generale,
    ...BoLangues,
    cash: {
      flux,
      statement,
      referentiel,
      settings,
      treatment,
      accounting,
      accounting_export,
      ratecurrency,
    },
    administration: {
      communication,
      interfaces,
      customisation,
      audit,
      parametrage,
    },
    treasury: {
      remuneration,
      quotidienne,
      reporting,
      settings: Settings,
      currentAccount,
      evenement,
      debt,
      Budgets,
    },
    document: {
      document,
    },
    user: {
      profile: {
        dashboard_modal: {
          account: 'Mon Compte',
          logout: 'Déconnexion',
          change_log: 'Version',
          settings: 'Paramétrage',
        },
        title: 'Mon Compte',
        buttons: {
          save: 'Valider',
          blocked_device: "Bloquer l'appareil",
          authorized_device: "Autoriser l'appareil",
          change: 'Changer le mot de passe',
          qrCode: 'Activer la 2FA',
          edit_qrCode: 'Consulter/Modifier',
          disable_qrCode: 'Désactiver la 2FA',
          totpTxt:
            "Scannez le code QR via une application d'authentification, puis tapez le code à 6 chiffres.",
        },
        tabs: {
          title: {
            informations: 'Mes informations',
            password: 'Mot de passe',
            entities: 'Mes entités',
            connected_devices: 'Mes appareils connectés',
            download: 'Téléchargement',
            card_title_download: 'Téléchargement OpenCash Parapheur',
            card_title_download_pouvoir: 'Téléchargement OpenCash Pouvoir',
            button_name: 'Télécharger',
          },
          champ_titles: {
            login: 'Login',
            email: 'Email',
            last_name: 'Nom',
            first_name: 'Prénom',
            phone_number: 'Téléphone',
            fax: 'Fax',
            mobile_number: 'Mobile',
            receive_email: 'Réception email',
            language: 'Langue',
            new_password: 'Nouveau mot de passe',
            current_password: 'Mot de passe actuel',
            confirm_password: 'Confirmer mot de passe',
            otp_type: 'Type',
          },
          columns: {
            code: 'Code',
            name: 'Nom',
            defined: 'Définir en favori',
          },
        },
      },
    },
    dashboard: {
      widget,
    },
    composant,
    risk: {
      operationChange,
      cotationChange,
    },
  },
}

